module.exports = __webpack_public_path__ + "41d4956b765a5197a2a76aaf71787794.svg";